export const initialValues = {
    workerType: 'Pracownik - osoba cywilna',
    employerCompanyName: '',
    nip: '',
    // dateOfIllness: new Date(),
    // dateOfBackToWork: new Date(),
    importantInformation: '',
    agreement: false,
    personalInformation: {
        name: '',
        surname: '',
        email: '',
        phone: '',
        address: '',
        houseNumber: '',
        city: '',
        zipCode: '',
        pesel: '',
    },
};
